import React, { useEffect, useState } from "react";
import axios from "axios";
import ReuseTable from "./Table";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { format } from "date-fns";
import notify from "./ToastifyAlerts";
import { QuestionData } from "../Redux/Reducers/QBAdmin/EditQuestions";
import { ScenarioData } from "../Redux/Reducers/QBAdmin/Editscenario";
// import { LanguageQuestionData } from "../Redux/Reducers/QBAdmin/LanguageEditQuestions";
import { CheckLanguage } from "./CommonFunctions";
import { SelectLanguageData } from "../Redux/Reducers/Common/Language";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "./Axios";
import { DateDetailsData } from "../Redux/Reducers/Common/AssessmentDate";
import { SelecYearData } from "../Redux/Reducers/Common/Year";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";

export function ViewVerificationQStatus({ QId, Close }) {
  const [StatusData, SetStatusData] = useState();
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const VVQS = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/ViewVerificationQStatus?QuestionId=${QId}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const data = res.data.filter((item) =>
          ["Question Verification Status"].includes(item.field.trim())
        );
        SetStatusData(data);
      })
      .catch((err) => {
        Close();
      });
  };
  useEffect(() => {
    VVQS();
  }, []);

  const columns = [
    { name: "Old Value", selector: "oldStatusValueName" },
    { name: "New Value", selector: "newStatusValueName" },
    { name: "Comments", selector: "verificationComment" },
    { name: "Modified By", selector: "modifierName" },
    {
      name: "Modified Date",
      selector: "modifiedDate",
      cell: (row) => format(new Date(row.modifiedDate), "MM/dd/yyyy HH:mm"),
    },
  ];
  return (
    <>
      {StatusData && (
        <div className="Model-Open">
          <div className="Card  m-4">
            <div className="dflex JSBetween">
              <div className="SubHeading">
                Question Verification Status - {StatusData?.[0]?.questionId}
              </div>
              <IoMdCloseCircleOutline
                className="NCERTClose CPointer"
                onClick={() => {
                  SetStatusData();
                  Close();
                }}
              />
            </div>
            <ReuseTable
              className="NCLDataTable"
              data={StatusData}
              columns={columns}
            />
          </div>{" "}
        </div>
      )}
    </>
  );
}

export function ViewQuestionStatus({ QId, Close }) {
  const [QuestionData, SetQuestionData] = useState();
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const VQS = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/ViewVerificationQStatus?QuestionId=${QId}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        // const data = res.data.filter((item) => item.field.trim() === 'Question','OptionA','OptionB','OptionC','OptionD')
        const data = res.data.filter((item) =>
          ["Question", "Option A", "Option B", "Option C", "Option D"].includes(
            item.field.trim()
          )
        );
        SetQuestionData(data);
      })
      .catch((err) => {
        Close();
      });
  };
  useEffect(() => {
    VQS();
  }, []);

  const columns = [
    { name: "Field", selector: "field" },
    { name: "Comments", selector: "verificationComment" },
    { name: "Modified By", selector: "modifierName" },
    {
      name: "Modified Date",
      selector: "modifiedDate",
      cell: (row) => format(new Date(row.modifiedDate), "MM/dd/yyyy HH:mm"),
    },
  ];
  return (
    <>
      {QuestionData && (
        <div className="Model-Open">
          <div className="Card  m-4">
            <div className="dflex JSBetween mt-2">
              <div className="SubHeading">
                Question Status - {QuestionData?.[0]?.questionId || QId}
              </div>
              <IoMdCloseCircleOutline
                className="NCERTClose CPointer"
                onClick={() => {
                  SetQuestionData();
                  Close();
                }}
              />
            </div>
            <DataTable
              className="NCLDataTable"
              data={QuestionData}
              columns={columns}
              Dropdownvalues={["10", "25"]}
              ShowPagination="true"
            />
          </div>{" "}
        </div>
      )}
    </>
  );
}

const ScenarioDelete = async (SId, dispatch) => {
  await axios
    .get(
      process.env.REACT_APP_API_BASE_URL +
      `/Scenario/DeleteScenario?ScenarioId=${SId}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
    .then((res) => {
      notify("Scenario deleted Successfully", "success");
    })
    .catch((err) => {
      console.log(err);
      notify("Scenario not deleted Successfully", "error");
    });
};
export default ScenarioDelete;

export async function QuestionDelete(QId, setModalState, dispatch) {
  await axios
    .get(
      process.env.REACT_APP_API_BASE_URL +
      `/QuestionBank/GetLastQuestionLO?QuestionId=${QId}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
    .then((res) => {
      switch (res.data[0]?.isLastQInLO) {
        case 1:
          setModalState({
            open: true,
            message: (
              <div style={{ position: "relative" }}>
                <p>
                  {" "}
                  Please note that this is the last Q in this scenario
                  associated with <b>{res.data[0].loName}</b>. If you happen to
                  delete this question the scenario will also get removed from{" "}
                  <b>{res.data[0].loName}</b>, as the scenario is not originally
                  created and mapped to <b>{res.data[0].loName}</b>. Are you
                  sure you want to delete the last question and thereby the
                  scenario?
                </p>
                <button
                  className="Buttons"
                  style={{ position: "fixed", right: "34vw" }}
                  onClick={() => {
                    axios
                      .get(
                        process.env.REACT_APP_API_BASE_URL +
                        `/QuestionBank/DeleteQuestion?QuestionId=${QId}`,
                        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
                      )
                      .then((res) => {
                        setModalState(true);
                        notify("Question deleted successfully", "success");
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                >
                  ok
                </button>{" "}
              </div>
            ),
          });
          break;

        case 2:
          alert("Question used in the Assessments, cannot be deleted.");
          break;
        case 0:
          if (window.confirm("Are you sure you want to delete the question?")) {
            axios
              .get(
                process.env.REACT_APP_API_BASE_URL +
                `/QuestionBank/DeleteQuestion?QuestionId=${QId}`,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
              )
              .then((res) => {
                setModalState(true);
                notify("Question deleted successfully", "success");
              })
              .catch((err) => {
                console.log(err);
              });
          }
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

export async function QuestionPreview(
  Row,
  dispatch,
  navigate,
  location,
  RScenario
) {
  if (RScenario) {
    dispatch(ScenarioData({ ScenarioDetails: "" }));
  }
  dispatch(QuestionData({ QuestionDetails: Row }));
  navigate("/QBAdmin/PreviewQuestion", { state: { Tab: location.state?.Tab } });
}

export async function GetQuestionDetails(
  SLanguage,
  Row,
  dispatch,
  navigate,
  SetLoad,
  location,
  RScenario, Filter = false
) {
  SetLoad(true);
  dispatch(ScenarioData({ ScenarioDetails: "" }));

  try {
    const res = await axios.get(
      process.env.REACT_APP_API_BASE_URL +
      `/QuestionBank/GetQuestionByQuestionId?QuestionId=${Row}&LanguageId=${SLanguage}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    );

    let Data = res.data.map((row) => ({
      ...row,
      elementType:
        row.elementType?.length > 0
          ? row.elementType.split(",").map((num) => parseInt(num, 10))
          : [],
      status: row.status ? row.status.split(",") : [],
    }));
    dispatch(QuestionData({ QuestionDetails: Data[0] }));

    const scenarioRes = await axiosInstance.get(
      `/Scenario/GetScenarioById?ScenarioId=${Data[0].scenarioID}&LoLovId=0&LanguageId=${SLanguage}`
    );

    let ScenarioComplete = {
      ...scenarioRes.data,
      status: scenarioRes.data?.status
        ? scenarioRes.data.status.split(",")
        : [],
    };

    dispatch(ScenarioData({ ScenarioDetails: ScenarioComplete }));

    SetLoad(false);
// if(Filter){
// navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
//         state: { Tab: location.state?.Tab, APathe: location.pathname },
//       });
//         return "";
// }
    if (CheckLanguage(parseInt(SLanguage))?.[1]) {
      navigate("/QBAdmin/QuestionBank/TranslateQuestion", {
        state: { Tab: location.state?.Tab, APathe: location.pathname },
      });
    } else {
      navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
        state: { Tab: location.state?.Tab, APathe: location.pathname },
      });
    }
  } catch (err) {
    console.log(err);
    SetLoad(false);
  }
}

export async function GetScenarioDetails(
  SLanguage,
  SID,
  dispatch,
  navigate,
  SetLoad,
  location,
  StopNavigation,Filter = false
) {
  SetLoad(true);
  try {
    const res = await axiosInstance.get(
      `/Scenario/GetScenarioById?ScenarioId=${SID}&LoLovId=0&LanguageId=${SLanguage}`
    );
    //let Data = { ...res.data, status: res.data?.status?.split(",") || 0 };
    let Data = {
      ...res.data,
      status: res.data?.status ? res.data?.status.split(",") : [],
    };

    dispatch(ScenarioData({ ScenarioDetails: Data }));
    if (!StopNavigation) {
// if(Filter){
// navigate("/QBAdmin/QuestionBank/AddEditScenario", {
//           state: { Tab: location.state?.Tab },
//         });
//         return "";
// }

      if (CheckLanguage(parseInt(SLanguage))?.[1] ) {
        navigate("/QBAdmin/QuestionBank/TranslateScenario", {
          state: { Tab: location.state?.Tab, APathe: location.pathname },
        });
      } else if (location && (!CheckLanguage(parseInt(SLanguage))?.[1]) ) {
        navigate("/QBAdmin/QuestionBank/AddEditScenario", {
          state: { Tab: location.state?.Tab },
        });
      }
    }
    SetLoad(false);
  } catch (err) {
    console.log(err);
  }
}

// Below api for Science Update question details

export async function GetScienceQuestionDetails(
  SLanguage,
  Row,
  dispatch,
  navigate,
  SetLoad,
  location,
  RScenario,Filter = false
) {
  SetLoad(true);

  dispatch(ScenarioData({ ScenarioDetails: "" }));

  try {
    const res = await axios.get(
      process.env.REACT_APP_API_BASE_URL +
      `/ScienceQuestionBank/GetQuestionByQuestionId?QuestionId=${Row}&LanguageId=${SLanguage}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    );

    let Data = res.data.map((row) => ({
      ...row,
      elementType: row.elementType
        ? row.elementType.split(",").map((num) => parseInt(num, 10))
        : [],
      status: row.status ? row.status.split(",") : [],
    }));

    dispatch(QuestionData({ QuestionDetails: Data[0] }));

    const scenarioRes = await axiosInstance.get(
      `/Scenario/GetScenarioById?ScenarioId=${Data[0].scenarioId}&LoLovId=0&LanguageId=${SLanguage}`
    );

    let ScenarioComplete = {
      ...scenarioRes.data,
      status: scenarioRes.data?.status
        ? scenarioRes.data.status.split(",")
        : [],
    };

    dispatch(ScenarioData({ ScenarioDetails: ScenarioComplete }));

    SetLoad(false);
// if(Filter){
//    navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
//         state: { Tab: location.state?.Tab, APathe: location.pathname },
//       });
//         return "";
// }
    if (CheckLanguage(parseInt(SLanguage))?.[1]) {
      navigate("/QBAdmin/QuestionBank/TranslateQuestion", {
        state: { Tab: location.state?.Tab, APathe: location.pathname },
      });
    } else {
      navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
        state: { Tab: location.state?.Tab, APathe: location.pathname },
      });
    }
  } catch (err) {
    console.log(err);
    SetLoad(false);
  }
}

export async function LanguageOptions(dispatch) {
  await axios
    .get(
      process.env.REACT_APP_API_BASE_URL +
      `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=69&ParentLovId=0`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
    .then((res) => {
      const Data = Array.from(
        res.data
          .reduce(
            (map, item) =>
              map.set(item.lovId, {
                display: item.lovName,
                value: item.lovId,
              }),
            new Map()
          )
          .values()
      );
      localStorage.setItem("LanguageOptions", JSON.stringify(Data));
      const GetEnglish = Data.filter((item) => item.display === "English");

      dispatch(
        SelectLanguageData({ SLanguage: GetEnglish?.[0]?.value.toString() })
      );
    })
    .catch((err) => {
      console.log(err);
    });
}

// Below is QB English
// Below function is used for both English and Hindi
export async function GetEnglishScenarioDetails(
  SID,
  dispatch,
  navigate,
  SetLoad,
  location,
  EditScenario,
  StopNavigation
) {
  SetLoad(true);
  await axios
    .get(
      process.env.REACT_APP_API_BASE_URL +
      `/Scenario/GetLanguageScenarioById?ScenarioId=${SID}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
    .then((res) => {
      let Data = { ...res.data, status: res.data.status?.split(",") };
      dispatch(ScenarioData({ ScenarioDetails: Data }));
      if (!StopNavigation) {
        if (EditScenario) {
          navigate("/QBAdmin/QuestionBank/AddEditScenario", {
            state: { Tab: location.state?.Tab },
          });
        } else {
          navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
            state: { Tab: location.state?.Tab },
          });
        }
      }
      SetLoad(false);
    })
    .catch((err) => {
      console.log(err);
    });
}
// Below function is used for both English and Hindi
export async function GetEnglishQuestionDetails(
  Row,
  dispatch,
  navigate,
  SetLoad,
  location,
  RScenario
) {
  SetLoad(true);
  dispatch(ScenarioData({ ScenarioDetails: "" }));

  try {
    const res = await axios.get(
      process.env.REACT_APP_API_BASE_URL +
      `/EnglishQuestionBank/GetLanguageQuestionByQuestionId?QuestionId=${Row}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    );

    let Data = res.data.map((row) => ({
      ...row,
      elementType:
        row.elementType?.length > 0
          ? row.elementType.split(",").map((n) => parseInt(n, 10))
          : [],
      status: row.status ? row.status.split(",") : [],
    }));

    const Question = Data[0];
    dispatch(QuestionData({ QuestionDetails: Question }));

    const scenarioRes = await axios.get(
      process.env.REACT_APP_API_BASE_URL +
      `/Scenario/GetLanguageScenarioById?ScenarioId=${Question.scenarioID}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    );

    let ScenarioComplete = {
      ...scenarioRes.data,
      status: scenarioRes.data?.status
        ? scenarioRes.data.status.split(",")
        : [],
    };

    dispatch(
      ScenarioData({
        ScenarioDetails:
          scenarioRes.data?.scenarioID > 0 ? ScenarioComplete : "",
      })
    );

    SetLoad(false);
    navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
      state: { Tab: location.state?.Tab, APathe: location.pathname },
    });
  } catch (err) {
    console.log(err);
    SetLoad(false);
  }
}

// Below api is used for getting the state,region,district
export function DSR(props) {
  const [DSROptions, SetDSROptions] = useState();

  const GetDSRDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/CommonAPI/GetInstituteHierarchyValuesByParentId?InstituteId=${props.PId}&StateId=${props.SID}&RegionId=${props.RID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const RSDetails = res.data.map((item) => ({
          display: item.values,
          value: item.id,
        }));
        if (props.INALL) {
          if (parseInt(props.SID) !== -1) {
            SetDSROptions([{ display: "All", value: -1 }, ...RSDetails]);
          } else {
            SetDSROptions([{ display: "All", value: -1 }]);
          }
        } else {
          SetDSROptions(RSDetails);
        }
        let Selected = RSDetails.find(
          (item) => item.value === parseInt(props.SOption)
        );
        if (props.StoreValue) {

          if (parseInt(props.SID) !== -1) {
            props.StoreValue(Selected?.value || RSDetails[0].value);
          } else {
            props.StoreValue(-1);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        SetDSROptions();
      });
  };
  useEffect(() => {
    if (props.PId && props.SID) {
      GetDSRDetails();
    } else {
      SetDSROptions();
    }
  }, [props.PId, props.SID, props.RID]);
  return (
    <>
      <DropdownValues
        className={props.className}
        options={DSROptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}
// Above api is used for getting the state,region,district

//Below api is for getting the School details
export function SManagement(props) {
  const [SManagementOptions, SetSManagementOptions] = useState();

  const GetSManagementDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LovId}&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const RSDetails = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.lovId, {
                  display: item.lovDescription,
                  value: item.lovId,
                }),
              new Map()
            )
            .values()
        );
        SetSManagementOptions(RSDetails);
        // props.StoreOptions([...RSDetails, { display: "All", value: 0 }]);
        // props.StoreValue(RSDetails[0].value);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetSManagementDetails();
  }, []);
  return (
    <>
      <DropdownValues
        className={props.className}
        options={SManagementOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}

export async function UpdateHindiQVS(Qid, VSId, UId, SetLoad, dispatch,language) {
  SetLoad(true);
  await axios
    .get( 
      process.env.REACT_APP_API_BASE_URL +
      `/QuestionBank/UpdateHindiQuestionStatus?QuestionId=${Qid}&VerficationStatus=${VSId}&ModifiedBy=${UId}&language=${language}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
    .then((res) => {
      SetLoad(false);
      notify("Successfully changed Question Status", "success");
    })
    .catch((err) => {
      notify("Unable to change Question Status.PLease try again", "error");
    });
}

// Below is Assessment date drop down
export function AssessmentDates(props) {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const [AssOptions, SetAssOptions] = useState();
  const GetDates = async () => {
    SetAssOptions([]);
    try {
      const res = await axiosInstance.get(
        `/Principal/GetAssessmentTypesAndDatesByInstitute?Year=${USYear?.value
        }&InstituteId=${props.InstId}&UserId=${items?.userId}&SocietyId=${props.Society || 0
        }`
      );
      const SortData = [...res.data].sort((a, b) =>
        a.assessmentTypeName.localeCompare(b.assessmentTypeName)
      );
      const Options = SortData.map((Assessment) => ({
        display: Assessment.assessmentTypeName,
        value: Assessment.contestCreationId,
        ...Assessment,
      }));
      // if (SelectDate?.length === 0) {
      //   dispatch(DateDetailsData({ DateDetails: Options[0] }));
      // }
      let Selected = Options.find(
        (item) => item.value === parseInt(SelectDate.value)
      );
      dispatch(DateDetailsData({ DateDetails: Selected || Options[0] }));
      SetAssOptions(Options);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (props.InstId && USYear?.value) {
      GetDates();
    }
  }, [USYear?.value, props.InstId, props.Society]);
  const StoreAssDates = (e) => {
    const SelectList = AssOptions.find(
      (item) => item.contestCreationId === Number(e.target.value)
    );
    dispatch(DateDetailsData({ DateDetails: SelectList }));
  };
  const BGColor = (e) => {
    switch (e) {
      case 3:
        return "#fffbe3"; // Samagara
      case 2:
        return "#d5edff"; // Sadhana
      case 1:
        return "#d0fff1"; // Sodhana
    }
  };
  return (
    <>
      {/* <DropdownValues
        className="NCLDropdown"
        options={AssOptions}
        onChange={(e) => StoreAssDates(e)}
        selectoption={SelectDate?.value} labelname={props.labelname}
      /> */}
      {props.labelname}
      <select
        value={SelectDate?.value}
        onChange={(e) => StoreAssDates(e)}
        // disabled={props.disabled}
        className="NCLDropdown"
      >
        {/* {props.Displayname && <option value="">{props.Displayname}</option>} */}
        {AssOptions?.length > 0 ? (
          AssOptions.map((option, index) => (
            <option
              key={index}
              value={option.value}
              style={{ backgroundColor: BGColor(option.assessmentType) }}
            >
              {option.display}
            </option>
          ))
        ) : (
          <option value="">No Options Avaliable</option>
        )}
      </select>
      <input
        type="text"
        value={
          (AssOptions?.length > 0 && SelectDate?.examStartDate) ||
          AssOptions?.[0]?.examStartDate ||
          ""
        }
        className="NCLDropdown"
        style={{ width: "35%" }}
        disabled
      />
    </>
  );
}
// Above is Assessment date drop down
// Below is for grade drop down based on Institute,and dates
export async function InstituteGrades(InstId, SelectDate, USYear, UserId) {
  try {
    const res = await axiosInstance.get(
      `/NCLAdmin/GetGradeByInstituteAndAssessment?InstituteId=${InstId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}&Year=${USYear}&UserId=${UserId}`
    );
    return res.data;
  } catch (err) {
    console.log(err);
  }
}
// Above is for grade drop down based on Institute,and dates
// Below is for year drop down
export function YearDD() {
  const [Options, SetOptions] = useState();
  const dispatch = useDispatch();
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const GetYears = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=76&ParentLovId=0`
      );
      const formatOptions = res.data.map((item) => ({
        display: item.lovDescription,
        value: item.lovId,
      }));
      SetOptions(formatOptions);
      dispatch(SelecYearData({ SYear: USYear || formatOptions.at(-1) }));
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetYears();
  }, []);

  const StoreYear = (e) => {
    const SelectList = Options.find(
      (item) => item.value === Number(e.target.value)
    );
    // console.log(e.target.value, "SelectList", SelectList);
    dispatch(SelecYearData({ SYear: SelectList }));
    // dispatch(DateDetailsData({ DateDetails: SelectList }));
  };
  return (
    <DropdownValues
      className="NCLDropdown"
      options={Options}
      onChange={(e) => StoreYear(e)}
      selectoption={USYear?.value}
    />
  );
}
// Above is for year drop down

export function ViewUserActivityLog({ UserId,UTId, Close }) {
  const [userlogData, SetuserlogData] = useState();
  const VUAL = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/UserStatusLog?UserId=${UserId}&UserTypeId=${UTId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetuserlogData(res.data);
      })
      .catch((err) => {
        Close();
      });
  };
  useEffect(() => {
    VUAL();
  }, []);

  const columns = [
    { name: "LoginId", selector: "loginId" },
    { name: "Name", selector: "fullName" },
    { name: "Field", selector: "field" },
    { name: "Old Value", selector: "oldStatusValueName" },
    { name: "New Value", selector: "newStatusValueName" },
    { name: "Comments", selector: "comments" },
    {
      name: "Modified Date",
      selector: "modifiedDate",
      cell: (row) => format(new Date(row.modifiedDate), "MM/dd/yyyy HH:mm"),
    },
  ];
  return (
    <>
      {userlogData && (
        <div className="Model-Open">
          <div className="Card  m-4">
            <div className="dflex JSBetween mt-2">
              <div className="SubHeading ">Activity Log</div>
              <IoMdCloseCircleOutline
                className="NCERTClose CPointer"
                onClick={() => {
                  SetuserlogData();
                  Close();
                }}
              />
            </div>
            <DataTable
              className="NCLDataTable"
              data={userlogData}
              columns={columns}
              Dropdownvalues={["10", "25"]}
              ShowPagination="true"
            />
          </div>{" "}
        </div>
      )}
    </>
  );
}

export function AssessmentTypeNo(props) {
  const [AssTypeNo, SetAssTypeNo] = useState();

  const GetAsstTypeNoDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=73&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const ATDetails = res.data
          .filter(
            (TType) => TType?.lovDescription.split(" ")[0] === props.PID.display
          )
          .map((item) => ({
            display: item.lovDescription,
            value: item.lovId,
          }));
        SetAssTypeNo(ATDetails);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetAsstTypeNoDetails();
  }, [props.PID]);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={AssTypeNo}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function ElectiveGrades(props) {
  const [EOptions, SetEOptions] = useState();
  const GetEGrades = async () => {
    try {
      const res = await axiosInstance.get(`/School/GetElectiveSubjectforUser?LovcategoryId=67&UserId=${props.UserId}`);
      console.log("res", res.data);
      const OP = res.data.map((item) => ({
        display: item.electiveSubjectName,
        value: item.electiveSubjectId,
      }));
      SetEOptions(OP);
    }
    catch (err) { console.log(err) }
  }
  useEffect(() => {
    GetEGrades();
  }, [])
  return (
    <>
      <DropdownValues className={props.className} options={EOptions} selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)} labelname={props.labelname}
        disabled={props.disable} Displayname={props.Displayname} /></>
  )
}

export function ResultsElectiveSubject(props) {
    const [Options, SetOptions] = useState();
  const GetRES = async() => {
     try {
      const res = await axiosInstance.get(`/School/GetElectiveSubjectforAssessment?contestcreationId=${props.CCID}&AssessmentType=${props.AType}`);
      console.log("res", res.data);
      const OP = res.data.filter((ES)=>ES.isElective === 1)
      .map((item) => ({
        display: item.electiveSubjectName,
        value: item.electiveSubjectName,
      }));
      props.onChange(OP?.[0]?.display)
      SetOptions(OP);
    }
    catch (err) { console.log(err) }
  }
  useEffect(() => {
    GetRES();
  }, [])
  return (
    <>
      <DropdownValues className={props.className} options={Options} selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)} labelname={props.labelname}
        disabled={props.disable} Displayname={props.Displayname} /></>
  )
}